// create popup video player

export default function PopupVideoPlayer({
  videoUrl,
  isVideoPlayerVisible = false,
  setIsVideoPlayerVisible = () => {},
}) {
  if (!isVideoPlayerVisible) return <></>;

  return (
    <div
      className="PopupVideoPlayer"
      onClick={(e) => {
        setIsVideoPlayerVisible(false);
      }}>
      <div
        className="holder"
        onClick={(e) => {
          e.stopPropagation();
        }}>
        {isVideoPlayerVisible && (
          <video src={videoUrl} controls autoPlay controlsList="nodownload" />
        )}
        <div
          className="close-button"
          onClick={(e) => {
            setIsVideoPlayerVisible(false);
          }}>
          &times;
        </div>
      </div>
    </div>
  );
}
